export const AI_MENTOR_GROUPS = [
  {
    title: "Frontend Mentors",
    subtitle: "UI, state, rendering, performance, and product polish",
    mentors: [
      { id: "react_teacher", name: "React Teacher", desc: "Hooks, rendering, performance" },
      { id: "nextjs_mentor", name: "Next.js Mentor", desc: "Routing, SSR, app architecture" },
      { id: "javascript_teacher", name: "JavaScript Teacher", desc: "Closures, async, scope" },
      { id: "typescript_mentor", name: "TypeScript Mentor", desc: "Types, safety, scalable code" },
      { id: "css_ui_mentor", name: "CSS UI Mentor", desc: "Responsive layouts, spacing, polish" },
      { id: "tailwind_mentor", name: "Tailwind Mentor", desc: "Utility-first design systems" },
      { id: "accessibility_mentor", name: "Accessibility Mentor", desc: "A11y patterns and semantics" },
      { id: "frontend_testing_mentor", name: "Frontend Testing Mentor", desc: "RTL, Cypress, UI confidence" },
      { id: "animation_mentor", name: "Animation Mentor", desc: "Motion, micro interactions, flows" },
      { id: "design_system_mentor", name: "Design System Mentor", desc: "Components, tokens, consistency" },
    ],
  },
  {
    title: "Backend Mentors",
    subtitle: "APIs, databases, architecture, and scalability",
    mentors: [
      { id: "node_teacher", name: "Node.js Teacher", desc: "APIs, auth, backend logic" },
      { id: "express_mentor", name: "Express Mentor", desc: "REST APIs and middleware design" },
      { id: "backend_arch_mentor", name: "Backend Architecture Mentor", desc: "Services, layers, patterns" },
      { id: "api_design_mentor", name: "API Design Mentor", desc: "Contracts, versioning, DX" },
      { id: "postgres_mentor", name: "Postgres Mentor", desc: "Schema design, joins, indexing" },
      { id: "mongodb_mentor", name: "MongoDB Mentor", desc: "Documents, queries, modeling" },
      { id: "firebase_backend_mentor", name: "Firebase Backend Mentor", desc: "Firestore, functions, auth" },
      { id: "redis_mentor", name: "Redis Mentor", desc: "Caching, queues, fast systems" },
      { id: "microservices_mentor", name: "Microservices Mentor", desc: "Boundaries, messaging, scaling" },
      { id: "graphql_mentor", name: "GraphQL Mentor", desc: "Schema, resolvers, client flows" },
    ],
  },
  {
    title: "Mobile Mentors",
    subtitle: "Native-feel apps, performance, and app architecture",
    mentors: [
      { id: "rn_teacher", name: "React Native Teacher", desc: "Android, iOS, architecture" },
      { id: "flutter_mentor", name: "Flutter Mentor", desc: "Widgets, state, smooth mobile UX" },
      { id: "android_mentor", name: "Android Mentor", desc: "Kotlin, activities, lifecycle" },
      { id: "ios_mentor", name: "iOS Mentor", desc: "Swift, UIKit, native patterns" },
      { id: "expo_mentor", name: "Expo Mentor", desc: "Faster app setup and shipping" },
      { id: "mobile_perf_mentor", name: "Mobile Performance Mentor", desc: "Lag, memory, animation fixes" },
      { id: "mobile_ui_mentor", name: "Mobile UI Mentor", desc: "Navigation, gestures, responsiveness" },
      { id: "app_release_mentor", name: "App Release Mentor", desc: "Builds, store prep, deployment" },
      { id: "offline_sync_mentor", name: "Offline Sync Mentor", desc: "State, caching, resilience" },
      { id: "push_notification_mentor", name: "Push Notification Mentor", desc: "Triggers, flows, engagement" },
    ],
  },
  {
    title: "AI & Data Mentors",
    subtitle: "AI products, prompts, data flows, and model integration",
    mentors: [
      { id: "ai_app_mentor", name: "AI App Mentor", desc: "AI product ideas to shipped features" },
      { id: "openai_mentor", name: "OpenAI Integration Mentor", desc: "Prompts, APIs, chat workflows" },
      { id: "rag_mentor", name: "RAG Mentor", desc: "Retrieval systems and context design" },
      { id: "ml_fundamentals_mentor", name: "ML Fundamentals Mentor", desc: "Models, evaluation, basics" },
      { id: "data_science_mentor", name: "Data Science Mentor", desc: "Analysis, notebooks, metrics" },
      { id: "python_ai_mentor", name: "Python AI Mentor", desc: "Python workflows for AI tools" },
      { id: "nlp_mentor", name: "NLP Mentor", desc: "Language tasks and text pipelines" },
      { id: "vector_db_mentor", name: "Vector DB Mentor", desc: "Embeddings, search, retrieval" },
      { id: "prompt_engineering_mentor", name: "Prompt Engineering Mentor", desc: "Reliable prompts and guardrails" },
      { id: "ai_agent_mentor", name: "AI Agent Mentor", desc: "Tool use, actions, planning loops" },
    ],
  },
  {
    title: "Cloud & DevOps Mentors",
    subtitle: "Deployment, infra, monitoring, and production workflows",
    mentors: [
      { id: "aws_mentor", name: "AWS Mentor", desc: "Core services and real deployments" },
      { id: "docker_mentor", name: "Docker Mentor", desc: "Containers, images, local-to-prod" },
      { id: "kubernetes_mentor", name: "Kubernetes Mentor", desc: "Pods, services, orchestration" },
      { id: "cicd_mentor", name: "CI/CD Mentor", desc: "Pipelines, releases, automation" },
      { id: "vercel_mentor", name: "Vercel Mentor", desc: "Frontend deployment and scaling" },
      { id: "linux_mentor", name: "Linux Mentor", desc: "Servers, CLI, production basics" },
      { id: "observability_mentor", name: "Observability Mentor", desc: "Logs, metrics, tracing" },
      { id: "cloud_security_mentor", name: "Cloud Security Mentor", desc: "Secrets, access, safe infra" },
      { id: "terraform_mentor", name: "Terraform Mentor", desc: "Infra as code and environments" },
      { id: "sre_mentor", name: "SRE Mentor", desc: "Reliability, incidents, uptime mindset" },
    ],
  },
  {
    title: "Role-based Mentors",
    subtitle: "Career direction, expectations, and job readiness",
    mentors: [
      { id: "frontend_mentor", name: "Frontend Dev Mentor", desc: "Skills expected in companies" },
      { id: "backend_role_mentor", name: "Backend Dev Mentor", desc: "APIs, systems, backend growth" },
      { id: "fullstack_mentor", name: "Fullstack Dev Mentor", desc: "Balancing frontend and backend" },
      { id: "mobile_mentor", name: "Mobile App Dev Mentor", desc: "RN / Flutter careers" },
      { id: "devops_role_mentor", name: "DevOps Career Mentor", desc: "Infra paths and hiring signals" },
      { id: "data_role_mentor", name: "Data Career Mentor", desc: "Analytics, ML, data roles" },
      { id: "qa_role_mentor", name: "QA Automation Mentor", desc: "Testing roles and skill map" },
      { id: "product_engineer_mentor", name: "Product Engineer Mentor", desc: "Shipping with business context" },
      { id: "startup_engineer_mentor", name: "Startup Engineer Mentor", desc: "Generalist execution mindset" },
      { id: "remote_job_mentor", name: "Remote Job Mentor", desc: "Remote readiness and proof of work" },
    ],
  },
  {
    title: "Interview Mentors",
    subtitle: "Prep for interviews, rounds, and communication",
    mentors: [
      { id: "dsa_mentor", name: "DSA Mentor", desc: "Arrays, trees, graphs, problem solving" },
      { id: "system_design_mentor", name: "System Design Mentor", desc: "Scale, tradeoffs, architecture" },
      { id: "frontend_interview_mentor", name: "Frontend Interview Mentor", desc: "UI rounds and JS depth" },
      { id: "backend_interview_mentor", name: "Backend Interview Mentor", desc: "API, DB, architecture rounds" },
      { id: "hr_round_mentor", name: "HR Round Mentor", desc: "Stories, motivation, clarity" },
      { id: "resume_mentor", name: "Resume Mentor", desc: "Bullet points and proof of work" },
      { id: "portfolio_mentor", name: "Portfolio Mentor", desc: "What to show and how to explain it" },
      { id: "behavioral_mentor", name: "Behavioral Mentor", desc: "STAR answers and confidence" },
      { id: "mock_interview_mentor", name: "Mock Interview Mentor", desc: "Practice interview style thinking" },
      { id: "salary_negotiation_mentor", name: "Salary Negotiation Mentor", desc: "Offers, confidence, expectations" },
    ],
  },
  {
    title: "Core CS Mentors",
    subtitle: "Foundations for college, interviews, and stronger reasoning",
    mentors: [
      { id: "db_teacher", name: "Database Teacher", desc: "SQL, indexing, joins" },
      { id: "os_teacher", name: "OS Teacher", desc: "Processes, threads, memory" },
      { id: "cn_mentor", name: "Computer Networks Mentor", desc: "HTTP, TCP/IP, sockets" },
      { id: "oop_mentor", name: "OOP Mentor", desc: "Objects, inheritance, abstractions" },
      { id: "dbms_mentor", name: "DBMS Mentor", desc: "Transactions, normalization, design" },
      { id: "compiler_mentor", name: "Compiler Mentor", desc: "Parsing, lexing, translation basics" },
      { id: "algo_mentor", name: "Algorithms Mentor", desc: "Complexity and solving patterns" },
      { id: "cn_systems_mentor", name: "Distributed Systems Mentor", desc: "Consistency, replication, queues" },
      { id: "security_fundamentals_mentor", name: "Security Fundamentals Mentor", desc: "Auth, encryption, attack basics" },
      { id: "git_mentor", name: "Git Mentor", desc: "Branches, rebases, collaboration" },
    ],
  },
  {
    title: "Project Building Mentors",
    subtitle: "From idea to execution, polish, and shipping",
    mentors: [
      { id: "project_idea_mentor", name: "Project Idea Mentor", desc: "Choose projects that actually matter" },
      { id: "mvp_mentor", name: "MVP Mentor", desc: "Scope smaller, ship faster" },
      { id: "saas_project_mentor", name: "SaaS Project Mentor", desc: "Productized fullstack projects" },
      { id: "portfolio_project_mentor", name: "Portfolio Project Mentor", desc: "Resume-worthy project direction" },
      { id: "debugging_mentor", name: "Debugging Mentor", desc: "Fix blockers with a method" },
      { id: "refactor_mentor", name: "Refactor Mentor", desc: "Clean up messy code with confidence" },
      { id: "testing_project_mentor", name: "Testing Project Mentor", desc: "Add trust to shipped work" },
      { id: "api_integration_mentor", name: "API Integration Mentor", desc: "Third-party APIs without chaos" },
      { id: "payments_mentor", name: "Payments Mentor", desc: "Subscriptions, checkout, billing flows" },
      { id: "realtime_project_mentor", name: "Realtime Project Mentor", desc: "Sockets, chat, live updates" },
    ],
  },
  {
    title: "Security & Quality Mentors",
    subtitle: "Safer software and better engineering discipline",
    mentors: [
      { id: "web_security_mentor", name: "Web Security Mentor", desc: "XSS, CSRF, safe frontend patterns" },
      { id: "auth_security_mentor", name: "Auth Security Mentor", desc: "Sessions, tokens, secure access" },
      { id: "api_security_mentor", name: "API Security Mentor", desc: "Rate limits, validation, abuse control" },
      { id: "owasp_mentor", name: "OWASP Mentor", desc: "Common app security issues" },
      { id: "qa_process_mentor", name: "QA Process Mentor", desc: "Quality strategy and checks" },
      { id: "automation_testing_mentor", name: "Automation Testing Mentor", desc: "Fast test coverage that matters" },
      { id: "performance_testing_mentor", name: "Performance Testing Mentor", desc: "Load, bottlenecks, behavior" },
      { id: "bug_triage_mentor", name: "Bug Triage Mentor", desc: "Prioritization and clean debugging flow" },
      { id: "code_review_mentor", name: "Code Review Mentor", desc: "What to fix and what to ignore" },
      { id: "prod_incident_mentor", name: "Production Incident Mentor", desc: "Fixing live issues calmly" },
    ],
  },
];
